module.exports = __webpack_public_path__ + "static/media/epy_assess.fcf420e4.svg";